import { render, staticRenderFns } from "./PAside.vue?vue&type=template&id=5c222aca&scoped=true&"
import script from "./PAside.vue?vue&type=script&lang=ts&"
export * from "./PAside.vue?vue&type=script&lang=ts&"
import style0 from "./PAside.vue?vue&type=style&index=0&id=5c222aca&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c222aca",
  null
  
)

export default component.exports